import { render, staticRenderFns } from "./CompanyUserShow.vue?vue&type=template&id=4efa569e&scoped=true&"
import script from "./CompanyUserShow.vue?vue&type=script&lang=js&"
export * from "./CompanyUserShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efa569e",
  null
  
)

export default component.exports